import axios from '@/libs/api.request'

// 获取操作日志列表
export const getOperationLogList = (data) => {
  return axios.request({
    url: 'api/operation-log/list',
    method: 'post',
    data: data
  })
}

// 获取操作日志详情
export const getOperationLogDetail = (id) => {
  return axios.request({
    url: `api/operation-log/${id}`,
    method: 'get'
  })
}

// 获取操作统计
export const getOperationLogStatistics = (data) => {
  return axios.request({
    url: 'api/operation-log/statistics',
    method: 'post',
    data: data
  })
}

// 导出操作日志
export const exportOperationLogs = (data) => {
  return axios.request({
    url: 'api/operation-log/export',
    method: 'post',
    data: data
  })
}

